// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// ** Axios Imports
import API from "../../../../utility/custom/API";
import toast from "react-hot-toast";

export const getData = createAsyncThunk('appProducts/getData', async params => {
  let response = ''
  if (params.q.length > 0) {
     response = await API.get(`products?page=${params.page}&keyword=${params.q}`)
     
  } else {
     response = await API.get(`products?page=${params.page}`)
  }
  return {
    data: response.data,
    allData: response.data,
    totalPages: response.total,
    params
  
  }
})

export const getCurrentId = createAsyncThunk('appProducts/getCurrentId', async (id, { dispatch, getState }) => {
  return {
    currentId: id,
  }
})

export const deleteProducts = createAsyncThunk('appProducts/deleteProducts', async (id, { dispatch, getState }) => {
  const dataInfo = new FormData()
  dataInfo.append("id", id)
  dataInfo.append("_method", 'delete')
  await API.post(`/products`, dataInfo )
  toast.success("با موفقیت عملیات انجام شد")
  getCurrentId(null)
  await dispatch(getData(getState().products.params))
  return id
})


export const appProductsSlice = createSlice({
  name: 'appProducts',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    currentId:null,
    
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    }).addCase(getCurrentId.fulfilled, (state, action) => {
      state.currentId = action.payload.currentId
  
    })
  }
})

export default appProductsSlice.reducer
